import { useBanners } from 'common';
import cx from 'classnames';
import StepWizard from 'react-step-wizard';
import { defaultStepWizardProps } from '~/constants';
import { DismissibleBanner } from '~/components/splash-banner';
import { DataStore } from '~/store';
import { useExperience } from '~/hooks/use-experience';
import { useLeftNav } from '~/hooks/use-left-nav';
import { Fragment } from 'react';
import { PageContainer } from '@xbto/universal-components';

export const useInlineBanners = (wrapperCls = '') => {
  const { banner } = useBanners(DataStore);
  const showFundsExperience = useExperience();
  const { leftNavCls } = useLeftNav();

  const BannerContainer = showFundsExperience ? PageContainer : Fragment;

  return (
    <>
      {!!banner && (
        <BannerContainer fullHeight={false} paddingBottom={false}>
          <StepWizard
            className={cx(
              showFundsExperience ? wrapperCls : leftNavCls + ' px-10',
              'transition-all'
            )}
            {...defaultStepWizardProps}
          >
            <DismissibleBanner />
          </StepWizard>
        </BannerContainer>
      )}
    </>
  );
};
